import { SystemService } from "./SystemService";
import AuthService from "./AuthService";
import { v4 } from 'uuid';
import axios from "axios";
import { saveAs } from 'file-saver';

class VolumesService{

    systemService = null;
    api = null;
    authService = null;

    draftAssessments = [
        'K',
        'Ξ',
        'CLΞ',
        'CΞ',
        'K',
        'KΞ',
        'VΞ'
    ];

    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getVolumes(search = '', status, page = 1, perPage = 10){
        let user = this.authService.getUser();
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        if(!user){
            throw "Δεν είστε συνδεδεμένος";
        }
        if(!config){
            throw "Δεν έχετε επιλέξει Α/Χ";
        }
        let volumesPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/search', {wh: config.whCode, search: search || '', status, page: Number(page) || 1, perPage: Number(perPage) || 10}, { headers: { authorization: sessionid } }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject(e.message);
            });
        });
        return volumesPromise;
    }

    createVolume(volume){
        let addVolumePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            let config = this.authService.getConfig();
            volume.wh = config.whCode;
            volume.uuid = v4();
            if(config.whCode === '79'){
                volume.itemCode = '7000001';
            }
            this.api.post('volumes/create', volume, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject('H δημιουργία του όγκου απέτυχε, παρακαλώ προσπαθήστε ξανά');
            })
        });
        return addVolumePromise;
    }

    updateVolume(volume){
        let updateVolumePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            let config = this.authService.getConfig();
            if(config.whCode === '79'){
                volume.itemCode = '7000001';
            }
            this.api.post('volumes/update', volume, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => {
                resolve(r.data);
            }).catch(e => {
                reject('H ενημέρωση του όγκου απέτυχε, παρακαλώ προσπαθήστε ξανά');
            })
        });
        return updateVolumePromise;
    }

    addMeasurement(measurement){
        if(!measurement.width){
            throw "Το πλάτος είναι υποχρεωτικό";
        }
        if(!measurement.depth){
            throw "Tο ύψος είναι υποχρεωτικό";
        }
        if(!measurement.length){
            throw "Το μήκος είναι υποχρεωτικό";
        }
        let measurePromise = new Promise((resolve, reject) => {
            let sessionid = this.authService.getSessionId();
            this.api.post('volumes/measure', measurement, {
                headers: {
                  authorization: sessionid
                }
            }).then(r => {
                if(r.error){
                    reject(r);
                }
                else{
                    resolve(r.data);
                }
            }).catch(e => reject(e.message));
        });
        return measurePromise;
    }

    assess(assessment){
        if(!assessment.assessment){
            throw "Πρέπει να επιλέξετε βαθμό αξιολόγησης";
        }
        let sessionid = this.authService.getSessionId();
        let assessPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/assess', assessment, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => {
                if(r.error){
                    reject(r);
                }
                else{    
                    resolve(r.data);
                }
              }).catch(e => {
                reject(e.message);
              });
        });
        return assessPromise;
    }

    reassess(assessment){
        if(!assessment.assessment){
            throw "Πρέπει να επιλέξετε βαθμό αξιολόγησης";
        }
        let sessionid = this.authService.getSessionId();
        let assessPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/reassess', assessment, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => {
                if(r.error){
                    reject(r);
                }
                else{    
                    resolve(r.data);
                }
              }).catch(e => {
                reject(e.message);
              });
        });
        return assessPromise;
    }

    decideAssessment(v){
        let config = this.authService.getConfig();
        let ass = v.assessments;
        let finalAssessment = '';
        if(v.wh === '49' && ass.length > 0){
            return ass[0].assessment;
        }
        let positions = [];
        let assessmentsArr = config.products.reduce((assessments, p) => {
            return assessments.concat(p.assessments);
        }, []);
        // if(this.draftAssessments.includes(v.assessments[0].assessment)){
        //     return v.assessments[0].assessment;
        // }
        if((v.wh === '4') && ass.length === 2){
            for(let i = 0; i < ass.length; i ++){
                let a = ass[i].assessment;
                assessmentsArr = config.products.reduce((assessments, p) => {
                    return assessments.concat(v.wh === '79' ? p.firstAssessments : p.assessments);
                }, []);
                if(ass.filter(as => as.assessment === a).length > 1){
                    finalAssessment = a;
                    return a;
                }
                else{
                    positions.push(assessmentsArr.indexOf(a));
                }
            }
            let ind = Math.floor(positions.reduce((s, p) => s + p, 0)/positions.length);
            return assessmentsArr[ind];
        }
        if((v.wh === '79' || v.wh === '319') && ass.length === 1){
            return ass[0].assessment;
        }
        if(ass.length === 3){
            for(let i = 0; i < ass.length; i ++){
                let a = ass[i].assessment;
                
                if(ass.filter(as => as.assessment === a).length > 1){
                    finalAssessment = a;
                    return a;
                }
                else{
                    positions.push(assessmentsArr.indexOf(a));
                }
            }
            if(v.wh !== '29'){
                let ind = Math.floor(positions.reduce((s, p) => s + p, 0)/positions.length);
                return assessmentsArr[ind];
            }
            else{
                let positionsVK = [];
                const assessmentsV = assessmentsArr.filter(a => a.includes('V'));
                const assessmentsK = assessmentsArr.filter(a => a.includes('K'));
                const assessmentsNB = assessmentsArr.filter(a => a.includes('NB'));
                for(let i = 0; i < ass.length; i ++){
                    let a = ass[i];
                    if(a.assessment.includes('V')){
                        positionsVK.push(assessmentsV.indexOf(a.assessment));
                    }
                    if(a.assessment.includes('K')){
                        positionsVK.push(assessmentsK.indexOf(a.assessment));
                    }
                    if(a.assessment.includes('NB')){
                        positionsVK.push(assessmentsNB.indexOf(a.assessment));
                    }
                }
                let ind = Math.floor(positionsVK.reduce((s, p) => s + p, 0)/positionsVK.length);
                if(ass.filter(a => a.assessment.includes('V')).length >= 2){
                    return assessmentsV[ind];
                }
                else if(ass.filter(a => a.assessment.includes('NB')).length >= 2){
                    return assessmentsNB[ind];
                }
                else{
                    return assessmentsK[ind];
                }
            }
        }
        else return '';
    }

    decideReAssessment(v){
        let config = this.authService.getConfig();
        let ass = v.assessments.filter(a => a.isReAssessment);
        let finalAssessment = '';
        if(v.wh === '49' && ass.length > 0){
            return ass[0].assessment;
        }
        let positions = [];
        let assessmentsArr = config.products.reduce((assessments, p) => {
            return assessments.concat(p.assessments);
        }, []);
        if(this.draftAssessments.includes(v.assessments[0].assessment)){
            return v.assessments[0].assessment;
        }
        if(config.whCode === '79' && ass.length === 2){
            for(let i = 0; i < ass.length; i ++){
                let a = ass[i].assessment;
                assessmentsArr = config.products.reduce((assessments, p) => {
                    return assessments.concat(p.firstAssessments);
                }, []);
                if(ass.filter(as => as.assessment === a).length > 1){
                    finalAssessment = a;
                    return a;
                }
                else{
                    positions.push(assessmentsArr.indexOf(a));
                }
            }
            let ind = Math.floor(positions.reduce((s, p) => s + p, 0)/positions.length);
            return assessmentsArr[ind];
        }
        else if(ass.length === 3){
            if(config.whCode === '79'){
                return ass[2].assessment;
            }
            for(let i = 0; i < ass.length; i ++){
                let a = ass[i].assessment;
                
                if(ass.filter(as => as.assessment === a).length > 1){
                    finalAssessment = a;
                    return a;
                }
                else{
                    positions.push(assessmentsArr.indexOf(a));
                }
            }
            let ind = Math.floor(positions.reduce((s, p) => s + p, 0)/positions.length);
            return assessmentsArr[ind];
        }
        else return '';
    }

    getVolumeItem(v) {
        try{
            let assessment = this.decideAssessment(v);
            let config = this.authService.getConfig();
            if(v.wh !== '79' && v.wh !== '319')
                return config.products.filter(p => p.assessments.includes(assessment))[0].code;
            else return config.products.filter(p => p.firstAssessments.includes(assessment))[0].code;
        }
        catch(e){
            return '';
        }
    }
    
    getVolumeDescr(v) {
        try{
            let assessment = this.decideAssessment(v);
            let config = this.authService.getConfig();
            if(v.wh !== '79' && v.wh !== '319')
                return config.products.filter(p => p.assessments.includes(assessment))[0].name;
            else return config.products.filter(p => p.firstAssessments.includes(assessment))[0].name;
        }
        catch(e){
            return '';
        }
    }

    syncToErp(v) {
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        v.itemCode = this.getVolumeItem(v);
        v.finalAssessment = this.decideAssessment(v);
        let SyncPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/syncToErp', v, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return SyncPromise;
    }

    syncToErpFinalAssessment(v) {
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        v.finalAssessment = this.decideAssessment(v);
        let SyncPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/syncToErpFinal', v, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return SyncPromise;
    }

    weighVolume(weighing){
        let sessionid = this.authService.getSessionId();
        let weighPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/weigh', weighing, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return weighPromise;
    }

    completeVolume(v){
        let sessionId = this.authService.getSessionId();
        console.log(v);
        let completePromise = new Promise((resolve, reject) => {
            this.api.post(`volumes/complete`, v, {
                headers: {
                    authorization: sessionId
                }
            }).then(r => resolve(true)).catch(e => {
                reject(false);
            })
        });
        return completePromise;
    }

    approveVolume(volumeId){
        let sessionId = this.authService.getSessionId();
        console.log(volumeId);
        let approvePromise = new Promise((resolve, reject) => {
            this.api.post(`volumes/approve`, {volumeId}, {
                headers: {
                    authorization: sessionId
                }
            }).then(r => resolve(true)).catch(e => {
                reject(false);
            })
        });
        return approvePromise;
    }

    rejectVolume(volumeId){
        let sessionId = this.authService.getSessionId();
        console.log(volumeId);
        let rejectPromise = new Promise((resolve, reject) => {
            this.api.post(`volumes/reject`, {volumeId}, {
                headers: {
                    authorization: sessionId
                }
            }).then(r => resolve(true)).catch(e => {
                reject(false);
            })
        });
        return rejectPromise;
    }

    getReassessable(){
        let sessionId = this.authService.getSessionId();
        let config = this.authService.getConfig();
        let volumesPromise = new Promise((resolve, reject) => {
            this.api.get(`volumes/reassessable/${config.whCode}`, {headers: {authorization: sessionId}})
                .then(r => resolve(r.data)).catch(e => reject(e.response.data.message));
        });
        return volumesPromise;
    }

    startReassessment(volumeId){
        let sessionId = this.authService.getSessionId();
        const startReassessmentPromise = new Promise((resolve, reject) => {
            this.api.post(`volumes/startReassessment`, {volumeId}, {
                headers: {
                    authorization: sessionId
                }
            }).then(r => {
                console.log(r);
                resolve(r.data);
            }).catch(e => {
                console.log(e);
                reject(e.response.data.message)
            });
        });
        return startReassessmentPromise;
    }

    syncToErpRe(v) {
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        v.itemCode = this.getVolumeItem(v);
        v.finalAssessment = this.decideReAssessment(v);
        let SyncPromise = new Promise((resolve, reject) => {
            this.api.post('volumes/syncToErpRe', v, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return SyncPromise;
    }

    getStock(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let stockPromise = new Promise((resolve, reject) => {
            this.api.get(`volumes/stock/${config.whCode}`, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    getAllVolumes(self, dateFrom, dateTo){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        let stockPromise = new Promise((resolve, reject) => {
            this.api.post(`volumes/allVolumes/${config.whCode}`, {
                self,
                dateTo,
                dateFrom
            }, {
                headers: {
                  authorization: sessionid
                }
              }).then(r => resolve(r)).catch(e => reject(e.message));
        });
        return stockPromise;
    }

    exportVolumesToExcel(){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        console.log('exporting');
        this.api.get(`volumes/export/${config.whCode}`, {responseType: 'blob', headers: {authorization: sessionid}}).then(response => {
            console.log('received');
            console.log(response.data);
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            saveAs(blob, 'Blocks.xlsx');
        });
    }

    sendFinalAssessment(v){
        let config = this.authService.getConfig();
        let sessionid = this.authService.getSessionId();
        this.api.post(`volumes/finalAssessment`, {id: v.volumeId, assessment: v.finalAssessment}).then(response => {
            console.log('received');
            console.log(response.data);
            const blob = new Blob([response.data], {
                type: response.headers['content-type'],
            });
            saveAs(blob, 'Blocks.xlsx');
        });
    }

}

export default VolumesService;